// CANONICAL COPY (GH #7115). src/constants/obligations/obl-data-subject-rights.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-data-subject-rights',
  title: 'Verify data subject rights request handling',
  description:
    'Confirm that procedures exist to receive, authenticate, validate and respond to data subject requests under GDPR Articles 15–22 — access, rectification, erasure, restriction of processing, notification to recipients, data portability, objection and rights relating to automated individual decision-making including profiling. Requests shall be responded to without undue delay and in any event within one month of receipt (extendable by two further months where necessary). Review the DSAR log for receipt date, identity verification, action taken, response date and any refusals with justification.',
  category: 'compliance',
  scfIds: ['SCF-PRV-003'],
  cadence: { frequency: '6m', anchor: 'domain' },
  strategy: 'any',
  fulfilmentCriteria: [
    {
      type: 'dsr-no-overdue-requests',
      description:
        'No data subject requests are overdue past their 30-day (or 90-day extended) response deadline',
    },
    { type: 'document-published', description: 'Data subject rights procedure is published' },
    { type: 'document-approved', description: 'Procedure has been approved' },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
